module.exports = __webpack_public_path__ + "img/check_box_outline_blank-24px.e88e9f09.svg";